import classNames from 'classnames';
import React from 'react';

export default function TransitionText({
    children,
    className = '',
    state = 'init', // init | in | leave
    delay = 0,
    duration = 300,
    easing = 'ease-in-out',
    distance = { init: 50, out: -50 },
    ...other
}) {
    let styles = {};
    if (state === 'init') {
        styles = {
            transform: `translateY(${distance.init}px)`,
            opacity: 0,
        };
    } else if (state === 'in') {
        styles = {
            transform: 'translateY(0px)',
            opacity: 1,
        };
    } else {
        styles = {
            transform: `translateY(${distance.out}px)`,
            opacity: 0,
        };
    }

    return (
        <div
            className={classNames(className)}
            style={{
                transition: `all ${duration}ms ${easing}`,
                transitionDelay: delay + 'ms',
                ...styles,
            }}
            {...other}
        >
            {children}
        </div>
    );
}
